export default __webpack_public_path__ + "static/squiseat-logo-ufficiale-senza-testo-53ab4f09a8794141a7ce6af321dd4a17.png";